import { AppErrorType } from "@obg/ngx.core";

/**
 * Registration status message codes returned from the API
 */
export const REGISTER_MESSAGE_CODE = {
	completed: "M_CUSTOMERREGISTRATIONTOKENS_COMPLETED",
	inProgress: "M_CUSTOMERREGISTRATIONTOKENS_INPROGRESS",
	registrationFailed: "M_CUSTOMERREGISTRATIONTOKENS_REGISTRATIONFAILED",
	awaitingAccountVerification: "M_CUSTOMERREGISTRATIONTOKENS_AWAITINGACCOUNTVERIFICATION",
	blockedByIovation: "M_CUSTOMERREGISTRATIONTOKENS_BLOCKEDBYIOVATION",
	blockedByGamstop: "E_CUSTOMERREGISTRATIONTOKENS_SELFEXCLUDEDFROMUK",
	blockedBySga: "E_CUSTOMERREGISTRATIONTOKENS_SELFEXCLUDEDFROMSGA",
	blockedByDjog: "E_CUSTOMERREGISTRATIONTOKENS_SELFEXCLUDEDFROMDGOJ",
	dataMismatch: "E_CUSTOMERREGISTRATIONTOKENS_DATAMISMATCH",
	minUserAgeCanadian: "E_VALIDATION_PERSON_DATEOFBIRTH_CANADIAN",
	nonUniqueAccount: "E_CUSTOMERREGISTRATIONTOKENS_ACCOUNTNOTUNIQUE",
	personalCodeInUse: "E_CUSTOMERREGISTRATIONTOKENS_PERSONALCODEINUSE",
	invalidEmail: "E_CUSTOMERREGISTRATIONTOKENS_EMAILINVALID",
	unknownError: "E_CUSTOMERREGISTRATIONTOKENS_UNKNOWNERROR",
	requiredParameter: "E_VALIDATION_REQUIREDPARAMETER",
	documentNumberInUse: "E_CUSTOMERREGISTRATIONTOKENS_DOCUMENTNUMBERINUSE",
	selfExcludedCentrally: "E_CUSTOMERREGISTRATIONTOKENS_SELFEXCLUDEDCENTRALLY",
	personalDataUnknownError: "E_PERSONALDATA_UNKNOWNERROR",
	personalDataCpfNotFound: "E_PERSONALDATA_CPFNOTFOUND",
	personalDataFullNameMisMatch: "E_PERSONALDATA_FULLNAMEMISMATCH",
	personalDataDateOfBirthMisMatch: "E_PERSONALDATA_DATEOFBIRTHMISMATCH",
	personalDataFullNameInvalid: "E_PERSONALDATA_FULLNAMEINVALID",
	personalDataProviderTimeout: "E_PERSONALDATA_PROVIDERTIMEOUT",
	personalDataDataMismatch: "E_PERSONALDATA_DATAMISMATCH",
	personalDataInvalidPersonalData: "E_PERSONALDATA_INVALIDPERSONALDATA",
	personalDataInvalidRequest: "E_PERSONALDATA_INVALIDREQUEST",
	personalDataUnauthorized: "E_PERSONALDATA_UNAUTHORIZED",
	personalDataTaskCancelled: "E_PERSONALDATA_TASKCANCELLED",
	customerRegistrationProviderTimeout: "E_CUSTOMERREGISTRATIONTOKENS_PROVIDERTIMEOUT",
	customerRegistrationDataMismatch: "E_CUSTOMERREGISTRATIONTOKENS_DATAMISMATCH",
	customerRegistrationInvalidPersonalDetails: "E_CUSTOMERREGISTRATIONTOKENS_INVALIDPERSONALDETAILS",
	customerRegistrationInvalidRequest: "E_CUSTOMERREGISTRATIONTOKENS_INVALIDREQUEST",
	customerRegistrationUnauthorized: "E_CUSTOMERREGISTRATIONTOKENS_UNAUTHORIZED",
	customerRegistrationTaskCancelled: "E_CUSTOMERREGISTRATIONTOKENS_TASKCANCELLED",
	customerRegistrationVerificationError: "E_CUSTOMERREGISTRATIONTOKENS_VERIFICATIONERROR",
	customerRegistrationSelfieMismatch: "E_CUSTOMERREGISTRATIONTOKENS_SELFIEMISMATCHERROR",
};

export const GENERIC_REGISTRATION_ERROR = "E_CUSTOMERREGISTRATIONTOKENS";

export const PARTIAL_FLOW_APP_ERROR_CODES = [
	AppErrorType.ServerError,
	AppErrorType.NotImplemented,
	AppErrorType.BadGateway,
	AppErrorType.ServiceUnavailable,
	AppErrorType.GatewayTimeout,
	AppErrorType.HttpVersionNotSupported,
	AppErrorType.VariantAlsoNegotiates,
	AppErrorType.InsufficientStorage,
	AppErrorType.LoopDetected,
	AppErrorType.NotExtended,
];

export const RNS_FEATURE_FLAG_KEY = "rns";
export const PAX_RNS_FEATURE_FLAG_KEY = "pax_rnsregistration";
